import { Vector3 } from "three";
import CurvedMesh from "./CurvedMesh";
import ResizingCanvas from "../ResizingCanvas";
import s from "./style.module.css";

const CurvedSection = () => {
  return (
    <section id="curved" className="section">
      <div className="container">
        <div className={s.textBox}>
          <h2 className={s.title}>
            Lorem Standard
            <br />
            Neque porro
            <br />
            quisquam dolorem
          </h2>
          <div className={s.description}>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Natus
            impedit sed ab nihil. Mollitia non deserunt porro voluptatum dolor
            doloribus quos vitae dolorum, maiores ratione vero ducimus laborum
            magnam. Et?
          </div>
        </div>
      </div>
      <ResizingCanvas
        id="canvas-curved"
        cameraOptions={{
          fov: 60,
          near: 0.1,
          far: 1000,
          position: new Vector3(0, 0, 20),
        }}
      >
        <CurvedMesh />
      </ResizingCanvas>
    </section>
  );
};

export default CurvedSection;
